import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";
export const LinkContent = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 0;
  color: ${color("text-brand")};
`;
